import { createContext, useContext, useState, useCallback } from 'react';
import { jwtDecode } from 'jwt-decode';
import { getAppEnv } from '../config/env';

const AuthContext = createContext(null);

const ADMIN_EMAILS = (getAppEnv('REACT_APP_ADMIN_EMAILS') || '')
  .split(',')
  .map((e) => e.trim().toLowerCase())
  .filter(Boolean);

function getStoredUser() {
  try {
    const raw = localStorage.getItem('umi_user');
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function AuthProvider({ children }) {
  const [user, setUser] = useState(getStoredUser);

  const handleGoogleSuccess = useCallback((credentialResponse) => {
    try {
      const decoded = jwtDecode(credentialResponse.credential);
      const email = decoded.email?.toLowerCase() || '';
      const role = ADMIN_EMAILS.includes(email) ? 'admin' : 'reader';

      const userData = {
        email,
        displayName: decoded.name || email,
        picture: decoded.picture || '',
        role,
        token: credentialResponse.credential,
      };

      localStorage.setItem('umi_user', JSON.stringify(userData));
      setUser(userData);
    } catch (err) {
      console.error('Failed to decode Google credential:', err);
    }
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem('umi_user');
    setUser(null);
  }, []);

  return (
    <AuthContext.Provider value={{ user, handleGoogleSuccess, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
